module.exports = __webpack_public_path__ + "img/19_63.f4f788f4.png";